import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type {
    MessageVariableFallbacksFormData,
    MessageVariableFallbacksResponse,
} from './messageVariableFallbacksClient.types';

class MessageVariableFallbacksClient extends BaseClient {
    getMessageVariableFallbacks(teamId: number): AxiosPromise<MessageVariableFallbacksResponse> {
        const url = `/api/v3/teams/${teamId}/message-variable-fallbacks`;
        return this.makeCoreApiRequest(url);
    }

    updateMessageVariableFallbacks(
        teamId: number,
        data: MessageVariableFallbacksFormData
    ): AxiosPromise<MessageVariableFallbacksResponse> {
        const url = `/api/v3/teams/${teamId}/message-variable-fallbacks`;
        return this.makeCoreApiRequest(url, 'put', data);
    }
}

export default new MessageVariableFallbacksClient();
